import { gql } from '@apollo/client';
import { notificationDetailsFragment } from 'graphql/user/fragments';

export const userNotificationCreatedSubscription = gql`
  subscription userNotificationCreated($user: ID!) {
    userNotificationCreated(user: $user) {
      ...notificationDetails
    }
  }
  ${notificationDetailsFragment}
`;
